import { cn } from "@plasma/utils/cn";
import { Eye } from "lucide-react";
import { type ComponentProps, useState } from "react";

import { Input } from "~/components/ui/input";

type PasswordInputProps = {
  containerClassName?: string;
} & Omit<ComponentProps<"input">, "type">;

export function PasswordInput({
  containerClassName,
  ref,
  ...props
}: PasswordInputProps) {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  return (
    <div className={cn("relative", containerClassName)}>
      <Input
        {...props}
        ref={ref}
        type={isPasswordShown ? "text" : "password"}
      />
      <button
        aria-label={isPasswordShown ? "Hide password" : "Show password"}
        className="absolute inset-y-3 right-5"
        onClick={() => {
          setIsPasswordShown((prev) => !prev);
        }}
        type="button"
      >
        <Eye className="text-foreground size-5" />
      </button>
    </div>
  );
}
